import lbaCountrySelect from "../lbaCountrySelect";

require('./lbaEditHotel.scss');

const lbaEditHotel = angular.module('app.lbaEditHotel', []);

lbaEditHotel.component('lbaEditHotel', {
  bindings: {},
  controllerAs: 'vm',
  controller: ['$rootScope', '$routeParams', 'settingsService', 'hotelsService', 'hotelTagService', 'Upload', 'hotelRatingProviderService', controller],
  template: require('./lbaEditHotel.html')
});

lbaEditHotel.service('hotelTagService', require('../../services/hotelTagService'));
lbaEditHotel.service('hotelRatingProviderService', require('../../services/hotelRatingProviderService'));

function controller($rootScope, $routeParams, settingsService, hotelsService, hotelTagService, Upload, hotelRatingProviderService) {
  let vm = this;
  vm.handleFile = handleFile;
  vm.activeContent = 'general';
  vm.blobUrl = blobUrl;
  vm.save = save;
  vm.getHotel = getHotel;
  vm.deleteImage = deleteImage;
  vm.addNewSerkoCode = addNewSerkoCode;
  vm.featureImageRadioChange = featureImageRadioChange;
  vm.newImageDescription = '';
  vm.tags = hotelTagService.get();
  vm.ratingProviders = hotelRatingProviderService.get();

  getHotel();
  settingsService.settings = settingsService.get();

  function getHotel() {
    hotelsService.getHotel($routeParams.hotelId).then(res => {
      vm.hotelData = res.data.Result;
      vm.hotelData.SustainabilityRatingExpiryDate = vm.hotelData.SustainabilityRatingExpiryDate ? new Date(vm.hotelData.SustainabilityRatingExpiryDate.slice(0, -9)) : null;
      vm.hotelData.Tags = vm.hotelData.Tags.map(tag => {
        return { Name: tag.Name }
      });
    })
  }

  function handleFile(file) {
    console.log('image: ', file);
    vm.uploadFailure = false;
    vm.filename = '';

    if (!file) {
      vm.uploadFailure = true;
      return false;
    }

    let fileExtension = file.name.substr(file.name.lastIndexOf('.'));
    let fileName;
    fileName = new Date() + '';
    fileName = fileName.replace(/[^\/\d]/g, '');
    fileName += fileExtension;

    Upload.upload({
      url: `${endPointUrl}/api/v2/hotels/uploadimage?hotelId=${vm.hotelData.Id}&description=${vm.newImageDescription}`,
      data: {file: file}
    }).then(function (resp) {
      vm.progressPercentage = 0;
      vm.uploadSuccess = true;
      vm.imageUploaded = resp.data.Result;
      vm.hotelData.Images.unshift({
        newImage: true,
        Url: vm.imageUploaded.Url,
        Description: vm.newImageDescription,
        HotelId: vm.imageUploaded.HotelId,
        Id: vm.imageUploaded.Id,
      });

    }, function (resp) {
      vm.uploadSuccess = false;
      vm.uploadFailure = true;
      console.log('Error status: ' + resp.status);
    }, function (evt) {
      vm.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
    });
  }

  function save() {
    $rootScope.$broadcast('lbaLoader:loaderState', {state: 'saving'});

    let SustainabilityRatingExpiryDate = vm.hotelData.SustainabilityRatingExpiryDate ? vm.hotelData.SustainabilityRatingExpiryDate.toJSON() : null;
    let hotelData = JSON.parse(JSON.stringify(vm.hotelData)); // decouple from AngularJS bindings
    hotelData.SustainabilityRatingExpiryDate = SustainabilityRatingExpiryDate ? SustainabilityRatingExpiryDate.slice(0, -5) : null;

    hotelsService.putHotel(hotelData).then(res => {
      $rootScope.$broadcast('lbaLoader:loaderState', { state: 'saved' });

    }).catch(() => {
      $rootScope.$broadcast('lbaLoader:loaderState', { state: 'error' });
    })
  }

  function deleteImage(imageIndex) {
    vm.hotelData.Images.splice(imageIndex, 1);
  }

  function addNewSerkoCode() {
    if (vm.hotelData.Providers.length > vm.hotelData.SerkoCodes.length) {
      const providers = angular.copy(vm.hotelData.Providers);

      vm.hotelData.SerkoCodes.forEach(serko => {
        providers.forEach((provider, index, obj) => {
          if (provider.Provider === serko.Provider) {
            obj.splice(index, 1);
          }
        })
      });

      vm.hotelData.SerkoCodes.unshift({
        Provider: providers[0].Provider,
        ExternalId: providers[0].ExternalId
      });
    }
  }

  function featureImageRadioChange(image) {
    vm.hotelData.Images.forEach(function(i) {
      i.Preferred = image.Id === i.Id;
    });
  }
}

export default lbaEditHotel;


// WEBPACK FOOTER //
// ./src/components/lbaEditHotel/lbaEditHotel.js